import { Component } from '@angular/core';
import { PortalPanelComponent } from '../../../portal-panel/portal-panel.component';

@Component({
  selector: 'app-code-reader-base',
  templateUrl: './code-reader-base.component.html',
  imports: [PortalPanelComponent],
})
export class CodeReaderBaseComponent {}
